module.exports = __webpack_public_path__ + "img/bluesky01.0cc40f5a.jpg";